import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BorderType } from 'common/types/styleTypes'
import React from 'react'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { ColorPickerControl } from './color-picker/color-picker-control'

interface BorderTypeControlProps {
  border: Partial<BorderType> | undefined
  mobileBorder?: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  mobileUpdate?: ((value: Partial<BorderType>) => void) | undefined
  label?: string
}

export const BorderColorControl = ({
  border,
  mobileBorder,
  update,
  mobileUpdate,
  label = 'website_styles_settings.border_color.label',
}: BorderTypeControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultBorder = getMobileOrDesktop(border, mobileBorder, isMobile)
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  return (
    <ColorPickerControl
      color={resultBorder?.color}
      update={value =>
        resultUpdate({
          ...resultBorder,
          color: value,
        })
      }
      label={label}
      singleColorMode
      isClearable
    />
  )
}
